const benefits = [
  {
    icon: "ri-search-eye-line",
    title: "Discover Popular Products",
    description: "The Vigorbuy Spreadsheet helps shoppers discover trending products, compare prices across categories, and find items that match your style with verified quality checks.",
  },
  {
    icon: "ri-shield-check-line",
    title: "QC Verified Reviews",
    description: "Every product listing includes detailed quality control documentation, helping you avoid low-quality items and make informed purchase decisions with confidence.",
  },
  {
    icon: "ri-ship-2-line",
    title: "Shipping Made Simple",
    description: "Access comprehensive shipping guides, cost calculators, and delivery time estimates to ensure your orders arrive smoothly without unexpected delays or fees.",
  },
  {
    icon: "ri-lock-star-line",
    title: "Safe Shopping Experience",
    description: "Learn essential safety tips, understand agent comparisons, and discover beginner-friendly tutorials that make the entire shopping journey secure and straightforward.",
  },
];

export default function WhyVigorbuy() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-5xl font-extrabold text-foreground-950 font-heading tracking-tight mb-4">
            Why Use Vigorbuy Spreadsheet?
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            The Vigorbuy Spreadsheet helps shoppers discover popular products, compare prices,
            review quality checks, and make informed buying decisions. Our guides simplify the
            entire shopping process from product selection to shipping.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="group p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-950 mb-3 font-heading">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}